import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  CSidebar,
  CSidebarHeader,
  CSidebarNav,
  CNavItem,
  CNavGroup,
  CSidebarToggler
} from '@coreui/react';
import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import CIcon from '@coreui/icons-react';
import { cilLayers, cilClearAll, cilHouse, cilUser, cilCheckCircle, cilAvTimer, cibCodesandbox, cibPypi, cilSpeech } from '@coreui/icons';
import './Sidebar.scss';
import logo from "../../../images/logo.png";

export const Sidebar = ({ setCustomerId, sidebarWidth, setSelectedFilter, onOpenMainWindow, resetCustomerId }) => {
  const [narrow, setNarrow] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [isCurrentOpen, setIsCurrentOpen] = useState(false);
  const [isCompletedOpen, setIsCompletedOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [sidebarContentKey, setSidebarContentKey] = useState(0);

  const token = localStorage.getItem('token');

  useEffect(() => {
    axios.get('/api/customers/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
      .then(response => {
        setCustomers(response.data);
      })
      .catch(error => console.error('Ошибка загрузки клиентов', error));
  }, []);

  const handleCustomerClick = (customerId) => {
    setCustomerId(customerId);
    setSelectedFilter(null);
    if (onOpenMainWindow) {
      onOpenMainWindow(customerId);
    }
  };

  const handleFilterClick = (filter) => {
    setSelectedFilter(filter);
    if (resetCustomerId) {
      resetCustomerId();
    } else {
      setCustomerId(null);
    }
    setIsCurrentOpen(false);
    setIsCompletedOpen(false);
  };

  function handleCloseSidebar() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("dark-content");
    }
    setSidebarOpen(false);
  }

  function handleOpenSidebar() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("light-content");
    }
    setSidebarOpen(true);
  }

  const handleAllObjectsClickFullReset = () => {
    handleFilterClick("all");
    setSidebarContentKey(prevKey => prevKey + 1);
  };

  return (
    <div key={sidebarContentKey}>
      <CSidebar className="border-end" style={{ width: `${sidebarWidth}px`, top: sidebarOpen ? '0px' : '-1000px' }} colorScheme="dark" narrow={narrow}>
        <CSidebarHeader style={{ width: `${sidebarWidth}px`, paddingTop: '8px', paddingBottom: '8px' }} className="border-bottom">
          <img src={logo} alt="Logo" style={{ maxHeight: '38px' }} />
        </CSidebarHeader>

        <CSidebarNav>
          <CNavItem
            onClick={handleAllObjectsClickFullReset}
            href="#"
          >
            <CIcon customClassName="nav-icon" icon={cilHouse} style={{ color: '#6BB0FF' }} /> Все объекты
          </CNavItem>
          <CNavGroup
            toggler={
              <>
                <CIcon customClassName="nav-icon" icon={cilAvTimer} style={{ color: 'orange' }} /> Текущие объекты
              </>
            }
            show={isCurrentOpen}
            onClick={() => {
              setIsCurrentOpen(!isCurrentOpen);
            }}
          >
            {customers['Текущие объекты']?.map((item, index) => {
                if (item.group) {
                  return (
                    <CNavGroup
                      key={`current-group-${index}`}
                      toggler={
                        <>
                          <CIcon customClassName="nav-icon" icon={cilClearAll} style={{ color: 'orange' }} /> {item.group}
                        </>
                      }
                    >
                      {item.items?.map((customer) => (
                        <CNavItem
                          key={customer.CustomerId}
                          onClick={() => handleCustomerClick(customer.CustomerId)}
                          href="#"
                        >
                          <CIcon customClassName="nav-icon" icon={cibCodesandbox} style={{ color: 'orange' }} /> {customer.CustomerName}
                        </CNavItem>
                      ))}
                    </CNavGroup>
                  );
                } else {
                  return (
                    <CNavItem
                      key={item.CustomerId || index}
                      onClick={() => handleCustomerClick(item.CustomerId)}
                      href="#"
                    >
                      <CIcon customClassName="nav-icon" icon={cibCodesandbox} style={{ color: 'orange' }} /> {item.CustomerName}
                    </CNavItem>
                  );
                }
              })}
          </CNavGroup>

          <CNavGroup
            toggler={
              <>
                <CIcon customClassName="nav-icon" icon={cilCheckCircle} style={{ color: 'green' }} /> Завершенные объекты
              </>
            }
            show={isCompletedOpen}
            onClick={() => {
              setIsCompletedOpen(!isCompletedOpen);
            }}
          >
            {customers['Завершенные объекты']?.map((item, index) => {
                if (item.group) {
                  return (
                    <CNavGroup
                      key={`completed-group-${index}`}
                      toggler={
                        <>
                          <CIcon customClassName="nav-icon" icon={cilClearAll} style={{ color: 'green' }} /> {item.group}
                        </>
                      }
                    >
                      {item.items?.map((customer) => (
                        <CNavItem
                          key={customer.CustomerId}
                          onClick={() => handleCustomerClick(customer.CustomerId)}
                          href="#"
                        >
                          <CIcon customClassName="nav-icon" icon={cibCodesandbox} style={{ color: 'green' }} /> {customer.CustomerName}
                        </CNavItem>
                      ))}
                    </CNavGroup>
                  );
                } else {
                  return (
                    <CNavItem
                      key={item.CustomerId || index}
                      onClick={() => handleCustomerClick(item.CustomerId)}
                      href="#"
                    >
                      <CIcon customClassName="nav-icon" icon={cibCodesandbox} style={{ color: 'green' }}  /> {item.CustomerName}
                    </CNavItem>
                  );
                }
              })}
          </CNavGroup>
        </CSidebarNav>

        <CSidebarHeader 
          className="border-top" 
          style={{ 
            display: 'flex', 
            justifyContent: narrow ? 'center' : 'space-between', 
            alignItems: 'center', 
            flexDirection: narrow ? 'column' : 'row', 
            padding: '10px 15px' 
          }}
        >
          <a
            href="https://t.me/AppStructuraSupport"
            target="_blank"
            rel="noopener noreferrer"
            className="support-btn-sidebar"
            title="Поддержка в Telegram"
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              color: 'rgba(255, 255, 255, 0.6)',
              marginBottom: narrow ? '15px' : '0'
            }}
          >
            <CIcon icon={cilSpeech} size="lg" />
            {!narrow && <span style={{ marginLeft: '10px', fontSize: '14px' }}>Поддержка</span>}
          </a>
          <CSidebarToggler onClick={() => setNarrow(!narrow)} />
        </CSidebarHeader>

        <button className="close-button-sidebar" onClick={handleCloseSidebar}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      </CSidebar>
      <button className="open-button-sidebar" onClick={handleOpenSidebar}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/></svg>
      </button>
    </div>
  );
};

export default Sidebar;